import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EntityTypes } from 'constants/entities';
import { IAsset } from 'types/app/asset';
import { IKeyArray } from 'types/IKeyArray';
import { MessageModel } from 'types/websocket';

export interface IWebsocketReducer {
  connection: ConnectionState;
}

export enum ConnectionState {
  PERMENENTLY_DISCONNECTED = -1,
  DISCONNECTED = 0,
  CONNECTING = 1,
  CONNECTED = 2,
}

export interface ISocketMessage {
  method: SocketMethods;
  type: EntityTypes;
  parentEntityId: number;
  parentEntityType: EntityTypes;
  entity: IProcessUpdate | any;
  uploadId?: string;
}

export interface IProcessUpdate {
  jobPercentComplete: number;
  currentPhase: ProcessPhase;
  filePath: string;
}

export enum ProcessPhase {
  PROCESSING = 'Processing',
  ENCODING = 'ENCODING',
  TRANSCODING = 'TRANSCODING',
  PROBING = 'PROBING',
  UPLOADING = 'UPLOADING',
}

export enum SocketMethods {
  PROCESSING = 'PROCESSING',
  UPDATE = 'UPDATE',
  /** The change was too large to send; re-fetch the entity. */
  REFRESH = 'REFRESH',
}

const initialState = {
  connection: ConnectionState.DISCONNECTED,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    updateConnectionState: (state, action: PayloadAction<ConnectionState>) => {
      state.connection = action.payload;
    },
    send: (state, action: PayloadAction<MessageModel>) => {},
    recieve: (state, action: PayloadAction<MessageModel>) => {},
    /** The socket came back after a drop; anything broadcast meanwhile was missed. */
    reconnected: state => {},
  },
  extraReducers: builder => {},
});

export const { updateConnectionState, send, recieve, reconnected } = websocketSlice.actions;

export default websocketSlice.reducer;
